import { BankType, NegotiationOption, NegotiationType, OutDebt } from '../generated/graphql';

const DAYS_BEHIND_LIMIT = 23;

export const getDaysBehindLimitKeyRappi = (
  { daysBehind, bank }: OutDebt,
  { type }: NegotiationOption,
) => {
  const isRappi = bank === BankType.Rappipay || bank === BankType.RappiPrestamo;
  const isQuotification = type === NegotiationType.Quotification;

  const daysBehindValue = daysBehind || 0;
  const isDaysBehindLimit = isRappi && isQuotification && daysBehindValue >= DAYS_BEHIND_LIMIT;

  return {
    isDaysBehindLimit,
    daysBehindLimitSubKey: isDaysBehindLimit ? '_days_behind_limit' : '',
  };
};
